module.exports = __webpack_public_path__ + "img/ai_white.8ac3998d.png";